import { SvelteComponent, init, safe_not_equal, element, text, attr, insert, append, set_data, detach, space, null_to_empty, toggle_class, noop, onMount, onDestroy } from '../../../../external_node_modules/svelte/internal/index.mjs.js';
import { t } from '../../../../i18n.js';
import '../../../../core/entity/product.entity.js';
import './Decoration.css.js';

/* src/ui/shared/components/Decoration/Decoration.svelte generated by Svelte v3.44.2 */

function create_if_block_4(ctx) {
	let div;
	let t0;
	let t1_value = /*product*/ ctx[0].formattedDiscount + "";
	let t1;

	return {
		c() {
			div = element("div");
			t0 = text("-");
			t1 = text(t1_value);
			attr(div, "class", "decoration-percent wcl-z6v7bk");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t0);
			append(div, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*product*/ 1 && t1_value !== (t1_value = /*product*/ ctx[0].formattedDiscount + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (71:2) {#if promoTimerActiveTill && countdownText}
function create_if_block_3(ctx) {
	let div;
	let t_1;

	return {
		c() {
			div = element("div");
			t_1 = text(/*countdownText*/ ctx[3]);
			attr(div, "class", "decoration-timer wcl-z6v7bk");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t_1);
		},
		p(ctx, dirty) {
			if (dirty & /*countdownText*/ 8) set_data(t_1, /*countdownText*/ ctx[3]);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (74:2) {#if product.promoLabels}
function create_if_block_2(ctx) {
	let div;
	let t_1_value = /*product*/ ctx[0].promoLabels + "";
	let t_1;

	return {
		c() {
			div = element("div");
			t_1 = text(t_1_value);
			attr(div, "class", "decoration-label wcl-z6v7bk");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t_1);
		},
		p(ctx, dirty) {
			if (dirty & /*product*/ 1 && t_1_value !== (t_1_value = /*product*/ ctx[0].promoLabels + "")) set_data(t_1, t_1_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (77:2) {#if isCountAvailable(product.availableCommonCount)}
function create_if_block_1(ctx) {
	let div;

	let t_1_value = t('Количество: {commonCount}', {
		commonCount: /*product*/ ctx[0].availableCommonCount
	}) + "";

	let t_1;

	return {
		c() {
			div = element("div");
			t_1 = text(t_1_value);
			attr(div, "class", "decoration-label wcl-z6v7bk");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t_1);
		},
		p(ctx, dirty) {
			if (dirty & /*product*/ 1 && t_1_value !== (t_1_value = t('Количество: {commonCount}', {
				commonCount: /*product*/ ctx[0].availableCommonCount
			}) + "")) set_data(t_1, t_1_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (82:2) {#if isCountAvailable(product.availablePersonalCount) && product.availablePersonalCount > 0}
function create_if_block(ctx) {
	let div;

	let t_1_value = t('Доступно для вас: {personalCount}', {
		personalCount: /*product*/ ctx[0].availablePersonalCount
	}) + "";

	let t_1;

	return {
		c() {
			div = element("div");
			t_1 = text(t_1_value);
			attr(div, "class", "decoration-label wcl-z6v7bk");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t_1);
		},
		p(ctx, dirty) {
			if (dirty & /*product*/ 1 && t_1_value !== (t_1_value = t('Доступно для вас: {personalCount}', {
				personalCount: /*product*/ ctx[0].availablePersonalCount
			}) + "")) set_data(t_1, t_1_value);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let t0;
	let t1;
	let t2;
	let show_if_1 = isCountAvailable(/*product*/ ctx[0].availableCommonCount);
	let t3;
	let show_if = isCountAvailable(/*product*/ ctx[0].availablePersonalCount) && /*product*/ ctx[0].availablePersonalCount > 0;
	let div_class_value;
	let if_block0 = /*product*/ ctx[0].formattedDiscount && !/*hidePercent*/ ctx[2] && create_if_block_4(ctx);
	let if_block1 = /*promoTimerActiveTill*/ ctx[4] && /*countdownText*/ ctx[3] && create_if_block_3(ctx);
	let if_block2 = /*product*/ ctx[0].promoLabels && create_if_block_2(ctx);
	let if_block3 = show_if_1 && create_if_block_1(ctx);
	let if_block4 = show_if && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			if (if_block2) if_block2.c();
			t2 = space();
			if (if_block3) if_block3.c();
			t3 = space();
			if (if_block4) if_block4.c();
			attr(div, "class", div_class_value = "" + (null_to_empty(/*display*/ ctx[1]) + " wcl-z6v7bk"));
			toggle_class(div, "decoration", true);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t0);
			if (if_block1) if_block1.m(div, null);
			append(div, t1);
			if (if_block2) if_block2.m(div, null);
			append(div, t2);
			if (if_block3) if_block3.m(div, null);
			append(div, t3);
			if (if_block4) if_block4.m(div, null);
		},
		p(ctx, [dirty]) {
			if (/*product*/ ctx[0].formattedDiscount && !/*hidePercent*/ ctx[2]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_4(ctx);
					if_block0.c();
					if_block0.m(div, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*promoTimerActiveTill*/ ctx[4] && /*countdownText*/ ctx[3]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_3(ctx);
					if_block1.c();
					if_block1.m(div, t1);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*product*/ ctx[0].promoLabels) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_2(ctx);
					if_block2.c();
					if_block2.m(div, t2);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (dirty & /*product*/ 1) show_if_1 = isCountAvailable(/*product*/ ctx[0].availableCommonCount);

			if (show_if_1) {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_1(ctx);
					if_block3.c();
					if_block3.m(div, t3);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (dirty & /*product*/ 1) show_if = isCountAvailable(/*product*/ ctx[0].availablePersonalCount) && /*product*/ ctx[0].availablePersonalCount > 0;

			if (show_if) {
				if (if_block4) {
					if_block4.p(ctx, dirty);
				} else {
					if_block4 = create_if_block(ctx);
					if_block4.c();
					if_block4.m(div, null);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}

			if (dirty & /*display*/ 2 && div_class_value !== (div_class_value = "" + (null_to_empty(/*display*/ ctx[1]) + " wcl-z6v7bk"))) {
				attr(div, "class", div_class_value);
			}

			if (dirty & /*display*/ 2) {
				toggle_class(div, "decoration", true);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if (if_block4) if_block4.d();
		}
	};
}

function isCountAvailable(count) {
	return typeof count === 'number' && count >= 0;
}

function pad(time, hideZero, symbol = ':') {
	if (hideZero) {
		return time > 0 ? String(time).padStart(2, '0') + symbol : '';
	} else {
		return String(time).padStart(2, '0') + symbol;
	}
}

function instance($$self, $$props, $$invalidate) {
	var _a;
	let { product } = $$props;
	let { display } = $$props;
	let { hidePercent } = $$props;

	let promoTimerActiveTill = (_a = product.promoTimerActiveTill) === null || _a === void 0
	? void 0
	: _a.getTime();

	let daysShortText = t('дн.');
	let countdownText = '';
	let countdownInterval = null;

	function renderCountdown(diff) {
		let diffTime = diff;
		let seconds = Math.floor(diffTime % 60) || 0;
		diffTime = diffTime / 60;
		let minutes = Math.floor(diffTime % 60) || 0;
		diffTime = diffTime / 60;
		let hours = Math.floor(diffTime % 24) || 0;
		let days = Math.floor(diffTime / 24) || 0;

		if (days > 0) {
			const renderedDays = days + (hours >= 12 ? 1 : 0);
			return `${renderedDays} ${daysShortText}`;
		} else {
			return `${pad(days, true)}${pad(hours, !days)}${pad(minutes, false)}${pad(seconds, !minutes, '')}`;
		}
	}

	function countdownTick() {
		const diff = Math.round((promoTimerActiveTill - Date.now()) / 1000);

		if (diff > 0) {
			$$invalidate(3, countdownText = renderCountdown(diff));
			return false;
		} else {
			$$invalidate(3, countdownText = null);
			return true;
		}
	}

	onMount(() => {
		if (promoTimerActiveTill) {
			if (countdownTick()) {
				return false;
			}

			countdownInterval = setInterval(
				() => {
					if (countdownTick()) {
						clearInterval(countdownInterval);
					}
				},
				1000
			);
		}
	});

	onDestroy(() => {
		clearInterval(countdownInterval);
	});

	$$self.$$set = $$props => {
		if ('product' in $$props) $$invalidate(0, product = $$props.product);
		if ('display' in $$props) $$invalidate(1, display = $$props.display);
		if ('hidePercent' in $$props) $$invalidate(2, hidePercent = $$props.hidePercent);
	};

	return [product, display, hidePercent, countdownText, promoTimerActiveTill];
}

class Decoration extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { product: 0, display: 1, hidePercent: 2 });
	}
}

export { Decoration as default };
//# sourceMappingURL=Decoration.svelte.js.map
